import { parse } from "date-fns";
import {
  TaskFormValues,
  ValidationFormErrors,
  ValidationFormsModeEnum,
} from "./types";
import { uk } from "date-fns/locale";

export function validateTask(
  values: TaskFormValues,
  mode: ValidationFormsModeEnum,
  original?: TaskFormValues
): ValidationFormErrors {
  const errors: ValidationFormErrors = {};

  if (!values.name || values.name.trim() === "") {
    errors.name = "Введіть назву.";
  }

  if (
    !values.deadline &&
    isNaN(
      parse(values.deadline!, "d-MMMM-yyyy", new Date(), {
        locale: uk,
      }).getTime()
    )
  ) {
    errors.deadline = "Введіть коректну дату.";
  }

  const hasEmptyMember = values.members.some(
    (item) => item.email !== "" && item.fullName === ""
  );

  if (hasEmptyMember) {
    errors.members = "Оберіть коректного користувача або видаліть запис.";
  }

  if (mode === "edit" && original) {
  }

  return errors;
}
